import React from 'react'
import { Icon } from '@chakra-ui/react'

const Grid = ({ ...props }) => {
  return (
    <Icon
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.05572 3.54543C5.45459 3.54543 5.77794 3.21982 5.77794 2.81816V0.999978C5.77794 0.598316 5.45459 0.272705 5.05572 0.272705C4.65685 0.272705 4.3335 0.598316 4.3335 0.999978V2.81816C4.3335 3.21982 4.65685 3.54543 5.05572 3.54543Z"
        fill="#83B53C"
      />
      <path
        d="M3.25 5.36363C3.25 4.96196 2.92665 4.63635 2.52778 4.63635H0.722222C0.32335 4.63635 0 4.96196 0 5.36363C0 5.76529 0.32335 6.0909 0.722222 6.0909H2.52778C2.92665 6.0909 3.25 5.76529 3.25 5.36363Z"
        fill="#83B53C"
      />
      <path
        d="M2.52778 11.9091H0.722222C0.32335 11.9091 0 12.2347 0 12.6363C0 13.038 0.32335 13.3636 0.722222 13.3636H2.52778C2.92665 13.3636 3.25 13.038 3.25 12.6363C3.25 12.2347 2.92665 11.9091 2.52778 11.9091Z"
        fill="#83B53C"
      />
      <path
        d="M12.2779 0.272705C11.879 0.272705 11.5557 0.598316 11.5557 0.999978V2.81816C11.5557 3.21982 11.879 3.54543 12.2779 3.54543C12.6768 3.54543 13.0001 3.21982 13.0001 2.81816V0.999978C13.0001 0.598316 12.6768 0.272705 12.2779 0.272705Z"
        fill="#83B53C"
      />
      <path
        d="M5.05572 14.4545C4.65685 14.4545 4.3335 14.7801 4.3335 15.1818V17C4.3335 17.4016 4.65685 17.7273 5.05572 17.7273C5.45459 17.7273 5.77794 17.4016 5.77794 17V15.1818C5.77794 14.7801 5.45459 14.4545 5.05572 14.4545Z"
        fill="#83B53C"
      />
      <path
        d="M12.2779 14.4545C11.879 14.4545 11.5557 14.7801 11.5557 15.1818V17C11.5557 17.4016 11.879 17.7273 12.2779 17.7273C12.6768 17.7273 13.0001 17.4016 13.0001 17V15.1818C13.0001 14.7801 12.6768 14.4545 12.2779 14.4545Z"
        fill="#83B53C"
      />
      <path
        d="M14.8057 6.0909H16.6113C17.0101 6.0909 17.3335 5.76529 17.3335 5.36363C17.3335 4.96196 17.0101 4.63635 16.6113 4.63635H14.8057C14.4068 4.63635 14.0835 4.96196 14.0835 5.36363C14.0835 5.76529 14.4068 6.0909 14.8057 6.0909Z"
        fill="#83B53C"
      />
      <path
        d="M16.6113 11.9091H14.8057C14.4068 11.9091 14.0835 12.2347 14.0835 12.6363C14.0835 13.038 14.4068 13.3636 14.8057 13.3636H16.6113C17.0101 13.3636 17.3335 13.038 17.3335 12.6363C17.3335 12.2347 17.0101 11.9091 16.6113 11.9091Z"
        fill="#83B53C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.2779 4.63635C12.6768 4.63635 13.0002 4.96196 13.0002 5.36363V12.6364C13.0002 13.038 12.6768 13.3636 12.2779 13.3636H5.05572C4.65685 13.3636 4.3335 13.038 4.3335 12.6364V5.36363C4.3335 4.96196 4.65685 4.63635 5.05572 4.63635H12.2779ZM11.1946 11.9091C11.3941 11.9091 11.5558 11.7463 11.5558 11.5454V6.45453C11.5558 6.2537 11.3941 6.0909 11.1946 6.0909H6.13909C5.93966 6.0909 5.77798 6.2537 5.77798 6.45453V11.5454C5.77798 11.7463 5.93966 11.9091 6.13909 11.9091H11.1946Z"
        fill="#83B53C"
      />
    </Icon>
  )
}

export default Grid
